var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 26340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8658 5.91196C17.7517 7.42108 18.114 9.18068 17.8963 10.917C17.6787 12.6534 16.8932 14.2691 15.6622 15.5128C14.4312 16.7566 12.8236 17.5586 11.0896 17.7941C9.3556 18.0296 7.59235 17.6854 6.07421 16.8151C4.55606 15.9447 3.36815 14.597 2.69524 12.9816C2.02234 11.3662 1.90219 9.57374 2.35349 7.883C2.8048 6.19226 3.80224 4.69808 5.19065 3.63291C6.57907 2.56774 8.28059 1.99132 10.0305 1.99331C11.4598 1.99097 12.8627 2.37856 14.088 3.11434L15.5265 1.66594C13.4601 0.295657 10.9584 -0.258101 8.50673 0.112149C6.05509 0.482399 3.82841 1.75024 2.25882 3.66963C0.689237 5.58902 -0.111341 8.02307 0.0124876 10.4994C0.136316 12.9758 1.1757 15.3178 2.92894 17.0711C4.68217 18.8243 7.02423 19.8637 9.50058 19.9875C11.9769 20.1113 14.411 19.3108 16.3304 17.7412C18.2497 16.1716 19.5176 13.9449 19.8878 11.4933C20.2581 9.04163 19.7043 6.53985 18.3341 4.47346L16.8658 5.91196Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99093 11.3677L6.32031 7.69703L7.71912 6.28831L9.99093 8.57004L18.225 0.335938L19.6238 1.74466L9.99093 11.3677Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.9822 0.991211H8.99805V3.9674H10.9822V0.991211Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9822 15.9229H8.99805V18.899H10.9822V15.9229Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.9684 8.97754H15.9922V10.9617H18.9684V8.97754Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.03868 8.97754H1.0625V10.9617H4.03868V8.97754Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2cdb40dd7f2c8f4745ca19680cca5be0.svg";
export { ForwardRef as ReactComponent };